// extracted by mini-css-extract-plugin
export var callCard = "_r7-0";
export var callMessageButton = "_r7-1";
export var helpIcon = "_r7-3";
export var helpIconContainer = "_r7-4";
export var verticalDivider = "_r7-2";